import { ExternalConfigLoader, usePendoTrackOffline } from '@/atoms'
import { useExposeRouterNavigator } from '@/routing'
import { Sections } from '@/sections'

import { Footer } from '@/components/Footer'
import { Header } from '@/components/Header'
import { LoadingState } from '@/components/LoadingState'

import { AppBody, AppContainer, AppContent, AppFooter, AppHeader } from '@/components/layout'

import { ResidentModals } from '@/components/modals/ResidentModals'

import { PopupRoot } from '../atoms/popup/context/PopupRoot'
import { Bootstrap } from './components/Bootstrap'
import { DomainSubscriptions } from './components/DomainSubscriptions'
import { GlobalKeybindings } from './components/GlobalKeybindings'
import { LanguageLoading } from './components/LanguageLoading'
import { TestActions } from './components/TestActions/TestActions'
import { ToastArea } from './components/ToastArea'

import { PopupFallback } from './components/PopupFallback'
import { useInstanceLicenses } from './hooks/useInstanceLicenses'
import { useOfflineMonitor } from './hooks/useOfflineMonitor'
import { useSetupBryntumSchedulerPresets } from './hooks/useSetupBryntumSchedulerPresets'
import { useUpdateLangAttributeOnHtml } from './hooks/useUpdateLangAttributeOnHtml'

export function App() {
  // instances Material UI X license
  useInstanceLicenses()

  // Setup Bryntum Scheduler presets
  useSetupBryntumSchedulerPresets()

  // communicates to the worker when window has gone offline
  useOfflineMonitor()

  // track online/offline event to pendo with offline duration
  usePendoTrackOffline()

  // Expose a static pointer to react-router `navigate()`
  useExposeRouterNavigator()

  // update lang attribute on html
  useUpdateLangAttributeOnHtml()

  return (
    <>
      <GlobalKeybindings />
      <DomainSubscriptions />
      <TestActions />
      <ExternalConfigLoader />

      <Bootstrap>
        <AppContainer>
          <AppContent>
            <PopupRoot>
              <LanguageLoading>
                <ResidentModals>
                  <PopupFallback />
                  <AppHeader>
                    {/* Application Header, it lives outside the URL router */}
                    <Header />
                  </AppHeader>

                  {/* Application content, it's driven by the URL router */}
                  <AppBody>
                    <Sections />
                  </AppBody>

                  {/* Application Footer, it lives outside the URL router */}
                  <AppFooter>
                    <Footer />
                  </AppFooter>
                </ResidentModals>
              </LanguageLoading>
            </PopupRoot>
          </AppContent>
        </AppContainer>
      </Bootstrap>

      <LoadingState />
      <ToastArea />
    </>
  )
}
